import type { SVGProps } from 'react';

const SvgClassC = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26674)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#FF38EE'
      />
      <path
        d='M12.0033 8.04175C12.2532 8.04177 12.487 8.1663 12.6263 8.37378L14.5247 11.2019L17.473 9.59155C17.7257 9.4535 18.0358 9.4727 18.2699 9.64038C18.5039 9.80807 18.621 10.095 18.5716 10.3787L17.4056 17.0837L17.4046 17.0828C17.3453 17.4377 17.0381 17.7087 16.6663 17.7087H7.33334C6.96871 17.7087 6.65656 17.4459 6.59408 17.0867L5.42709 10.3787C5.38917 10.1606 5.44971 9.93674 5.59213 9.76733C5.73463 9.59791 5.94496 9.49976 6.16635 9.49976H6.17026L6.26401 9.50562C6.35682 9.51735 6.44704 9.54644 6.52963 9.59155L9.47983 11.2039L11.3802 8.37378C11.5195 8.16626 11.7533 8.04176 12.0033 8.04175ZM10.3441 12.6091C10.1279 12.9311 9.70193 13.0353 9.36166 12.8494L7.17123 11.6521L7.96322 16.2087H16.0345L16.8265 11.6531L14.6429 12.8474C14.3028 13.0329 13.8775 12.9288 13.6615 12.6072L12.0033 10.1375L10.3441 12.6091Z'
        fill='white'
      />
      <path
        d='M5.58301 7.95874C6.3653 7.95874 6.99982 8.5925 7 9.37476C7 10.1572 6.36541 10.7917 5.58301 10.7917C4.80075 10.7916 4.16699 10.1571 4.16699 9.37476C4.16717 8.59261 4.80086 7.95892 5.58301 7.95874ZM18.416 7.95874C19.1983 7.95874 19.8328 8.5925 19.833 9.37476C19.833 10.1572 19.1984 10.7917 18.416 10.7917C17.6338 10.7916 17 10.1571 17 9.37476C17.0002 8.59261 17.6339 7.95892 18.416 7.95874ZM12 6.20874C12.7823 6.20874 13.4168 6.8425 13.417 7.62476C13.417 8.40716 12.7824 9.04175 12 9.04175C11.2177 9.04157 10.584 8.40705 10.584 7.62476C10.5842 6.84261 11.2179 6.20892 12 6.20874Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26674'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassC;
